import { MutationTree } from 'vuex';
import { CommonState as State } from '@/types/store/state';
import { Mutations } from '@/types/store/mutations';

export enum MutationTypes {
    SetApiUrl = 'SET_API_URL',
    SetSiteName = 'SET_SITE_NAME',
    SetPeriods = 'SET_PERIODS',
    SetFrequencies = 'SET_FREQUENCIES',
    SetSearches = 'SET_SEARCHES',
    SetCurrentSearch = 'SET_CURRENT_SEARCH',
    SetIsSubmitting = 'SET_IS_SUBMITTING',
    ApiErrorOccurred = 'API_ERROR_OCCURRED',
    SetNotificationFrequency = 'SET_NOTIFICATION_FREQUENCY',
    SetNotificationPeriod = 'SET_NOTIFICATION_PERIOD',
    SetEmail = 'SET_EMAIL',
    SetRememberDetails = 'SET_REMEMBER_DETAILS',
    SetNeedFocusEmail = 'SET_NEED_FOCUS_EMAIL',
    SetError = 'SET_ERROR',
    SetIsEmailError = 'SET_IS_EMAIL_ERROR',
    SetShowIncludeUk = 'SET_SHOW_INCLUDE_UK',
}

export const mutations: MutationTree<State> & Mutations = {
    [MutationTypes.SetApiUrl] (state, url) {
        state.apiUrl = url;
        state.searchForm.apiUrl = url;
    },
    [MutationTypes.SetSiteName] (state, name) {
        state.siteName = name;
    },
    [MutationTypes.SetPeriods] (state, periods) {
        state.periods = periods;
    },
    [MutationTypes.SetFrequencies] (state, frequencies) {
        state.frequencies = frequencies;
    },
    [MutationTypes.SetSearches] (state, searches) {
        state.searchForm.searches = searches;
    },
    [MutationTypes.SetCurrentSearch] (state, search) {
        state.searchForm.currentSearch = +search;
    },
    [MutationTypes.SetIsSubmitting] (state, isSubmitting) {
        state.isSubmitting = isSubmitting;
    },
    [MutationTypes.ApiErrorOccurred] (state) {
        state.isSubmitting = false;
        state.isLoading = false;
        state.hasApiError = true;
    },
    [MutationTypes.SetNotificationFrequency] (state, frequencyId) {
        state.notificationData = { ...state.notificationData, frequency: frequencyId };
    },
    [MutationTypes.SetNotificationPeriod] (state, periodId) {
        state.notificationData = { ...state.notificationData, period: periodId };
    },
    [MutationTypes.SetEmail] (state, email) {
        state.email = email;
    },
    [MutationTypes.SetRememberDetails] (state, remember) {
        state.rememberDetails = remember;
    },
    [MutationTypes.SetNeedFocusEmail] (state, value) {
        state.needFocusEmail = value;
    },
    [MutationTypes.SetError] (state, error) {
        state.error = error;
    },
    [MutationTypes.SetIsEmailError] (state, value) {
        state.isEmailError = value;
    },
    [MutationTypes.SetShowIncludeUk] (state, showIncludeUk) {
        state.showIncludeUk = showIncludeUk;
    }
};
